import { render, staticRenderFns } from "./home.vue?vue&type=template&id=2f655a62&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=2f655a62&prod&lang=stylus&scoped=true&external"
import style1 from "./home.vue?vue&type=style&index=1&id=2f655a62&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f655a62",
  null
  
)

export default component.exports